export default __webpack_public_path__ + "static/media/product-8.dcae4625.webp";